<template>
  <GiscubeLayout v-if="toolsLoaded">
    <slot />
  </GiscubeLayout>
</template>

<script>
import { GiscubeLayout } from '@giscube/geoportal'

export default {
  name: 'BasicLayout',
  components: { GiscubeLayout },
  data () {
    return {
      toolsLoaded: false
    }
  },
  created () {
    this.$store.dispatch('layout/fetchMapTools', this.$config).then(() => {
      this.toolsLoaded = true
    }).catch(error => {
      this.toolsLoaded = true
      this.$except(error)
    })
  }
}
</script>
